import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fullStory = defineConnector({
  identifier: "fullStory",
  name: "FullStory",
  tagLine: "Digital experience analytics",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () =>
    "https://api\\.(fullstory\\.com|eu1\\.fullstory\\.com)/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Basic",
      },
    ]),
  steps: [
    {
      title: "Get your FullStory API key",
      items: [
        {
          kind: "markdown",
          content:
            "In FullStory, go to **Settings > Integrations > API Keys** and create a new API key with the required scopes.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.fullstory.com/v2/operations",
  },
});
